import Articles from 'components/Articles';
import ChevronArrow from 'styles/icons/ChevronArrow';
import Container from 'components/SearchSection/primitives/Container';
import EyebrowText from './primitives/EyebrowText';
import NavLink from 'components/NavLink';
import PlayableArticle from 'shared/ui/components/PlayableArticle';
import Section from 'primitives/Section';
import SectionRightResults from 'components/SearchSection/primitives/SectionRightResults';
import theme from 'styles/themes/default';
import { Component } from 'react';
import { getRelativePath } from 'utils/url';
import { PLAY_PLAYLIST } from 'state/Entitlements/constants';
import { SEARCH_FILTERS } from 'state/Search/constants';

export default class SearchSection extends Component {
  static propTypes = {
    bestMatch: PropTypes.bool,
    data: PropTypes.array,
    filter: PropTypes.string,
    onSelected: PropTypes.func,
    playedFrom: PropTypes.number.isRequired,
    playedFromFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    title: PropTypes.string,
    totalNumResults: PropTypes.number,
  };

  static defaultProps = {
    onSelected: Function.prototype,
  };

  onCategoryClick = () => {
    document.getElementById('search-content').scrollTop = 0; // Force scroll to top after category click.
    const { filter } = this.props;
    this.props.setSearchFilter({ filter });
  };

  render() {
    let titleEl;
    let showAllEl;

    const {
      bestMatch = false,
      data: propsData,
      dataTest = 'search-section',
      filter,
      isTrialEligible,
      onSelected,
      playedFrom,
      playedFromFilter,
      selected,
      setTrackingData,
      subscriptionType,
      title,
      totalNumResults,
      translate,
    } = this.props;
    const path = getRelativePath();

    const data = propsData.map((datum, i) => {
      const el = { ...datum };

      if (el.url === path) {
        /*
           Clicking on an item which has the same url as the current url fragment
           doesn't trigger a route so nothing happens!
           So let's change the url and rely on the clickHandler to close the search modal instead.
        */
        el.url = null;
        el.onClick = e => {
          onSelected(e);
          setTrackingData({
            asset: el,
            exitType: 'item_selected',
            title,
            selected: i,
          });
          return true;
        };
      } else {
        el.deferPlay = true;
        if (el.catalogType && el.catalogId) {
          el.onClick = e => {
            onSelected(e);
            setTrackingData({
              asset: el,
              exitType: 'item_selected',
              title,
              selected: i,
            });
            return true;
          };
        } else {
          el.onClick = () => {
            setTrackingData({
              asset: el,
              exitType: 'item_selected',
              title,
              selected: i,
            });
            // IHRWEB-16820 Do not prevent defaults when content type is link.
            // This callback is invoked from NavLink. Default anchor tag behavior is prevented if onClick returns falsy
            return datum?.contentType === 'link';
          };
        }
      }
      // el.highlight = keywords; disable bolded/highlighted search keywords
      el.classes = selected === i ? ['selected'] : null;
      el.firstTrack = selected === i;
      el.itemSelected = selected === i;
      // information about the context necessary for analytics
      el.playedFrom = playedFrom;
      el.playedFromFilter = playedFromFilter;
      el.subscriptionType = subscriptionType;
      el.isTrialEligible = isTrialEligible;

      if (title === 'Playlists') {
        el.showPlayEntitlement = PLAY_PLAYLIST;
      }

      return el;
    });
    const showAllBreakpoint = totalNumResults > propsData.length;

    if (filter) {
      titleEl = (
        <NavLink onClick={this.onCategoryClick}>
          <EyebrowText>
            <p>{title}</p>
          </EyebrowText>
        </NavLink>
      );

      // Need to generate text for each because the grammar is different based on the
      // type in different languages
      const generateShowAllText = () => {
        switch (filter) {
          case SEARCH_FILTERS.LIVE:
            return translate('Show all Live Stations');
          case SEARCH_FILTERS.ARTIST:
            return translate('Show all Artists');
          case SEARCH_FILTERS.ALBUM:
            return translate('Show all Albums');
          case SEARCH_FILTERS.SONG:
            return translate('Show all Songs');
          case SEARCH_FILTERS.COLLECTION:
            return translate('Show all Playlists');
          case SEARCH_FILTERS.PODCAST:
            return translate('Show all Podcasts');
          default:
            return translate('Show all {title}', { title });
        }
      };

      showAllEl = showAllBreakpoint ? (
        <NavLink css={{ color: theme.colors.gray['400'] }} onClick={this.onCategoryClick}>
          <span data-test="search-show-all">{generateShowAllText()}</span>
          <ChevronArrow css={{ margin: '0 0 -2px 0' }} fill={theme.colors.gray.medium} />
        </NavLink>
      ) : (
        ''
      );
    } else {
      titleEl = (
        <EyebrowText>
          <p>{title}</p>
        </EyebrowText>
      );
    }

    return (
      <Container data-test={dataTest}>
        <Section omitMainStyles styles={{ width: 'auto' }} type="left">
          {titleEl}
        </Section>
        <SectionRightResults data-test="search-section-right" type="right">
          <Articles
            articleClass={PlayableArticle}
            bestMatch={bestMatch}
            data={data}
            filter={filter}
            hidePadding
            search
          />
          {showAllEl}
        </SectionRightResults>
      </Container>
    );
  }
}
